import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import HeaderAppBar from '../components/HeaderAppBar';
//pannels
import SearchCard from '../components/SearchCard';
import PlayListCard from '../components/PlayListCard';
import PreviewCard from '../components/PreviewCard';
import EffectsCard from '../components/EffectsCard';
import SearchResult from '../components/SearchResult';
import ScreenControlsCard from '../components/ScreenControlsCard';
import Player from './Player';
import ConfigModal from '../components/ConfigModal';
import { startInteractiveTour } from '../utils/interactiveTour';
//
import { Grid, Button } from '@mui/material';
import { ExternalLink } from 'lucide-react';

function Pannel({
                  playlist, 
                  setKeySearch, 
                  setVideosSearchResponse, 
                  keySearch, 
                  videosSearchResponse, 
                  setPlaylist, 
                  setPreviewVideoId, 
                  previewVideId, 
                  onIsKaraokeOnly, 
                  isKaraokeOnly,
                  setCurrentIntroVideo,
                  setCurrentTransitionVideo,
                  currentIntroVideo,
                  currentTransitionVideo,
                  user,
                  userSettings, 
                  openVideoPlayer,
                  showHideModalQR,
                  showHideModalMessage,
                  showModalMessage,
                  showModalQR,
                  showModalVotesTable,
                  videoPlayer,
                  setSnackMessage,
                  selectedApiKey,
                  setSelectedApiKey,
                  currentPlaylist,
                  setCurrentPlaylist,
                  myPlaylists,
                  setMyPlaylists,
                  onCreatePlaylist,
                  onRenamePlaylist,
                  onDeletePlaylist,
                  onAddToPlaylist,
                  userPresetPlaylists,
                  originPresetPlaylists,
                  setOriginPresetPlaylists,
                  originPresetPlaylist,
                  setOriginPresetPlaylist,
                  userPresetPlaylist,
                  setUserPresetPlaylist,
                  handleGoogleSignOut,
                  setCurrentPlaylistItem,
                  allowInteractivity,
                  setAllowInteractivity,
                  currentPlaylistItem,
                  setVideoId,
                  videoId,
                  showHideModalVotesTable,
                  auth,
                  saveUserSettings,
                  setShowControlsPlayer,
                  showControlsPlayer,
                  screenSettings,
                  onUpdateScreenSettings,
                  onResetScreenSettings,
                  updateUserField,
                  isIntegratedScreen = false,
                  onToggleIntegratedScreen,
                  isRemoteActive = false,
                  continuousPlay,
                  onToggleContinuousPlay,
                  crossfadeEnabled,
                  onToggleCrossfade,
                  crossfadeDuration,
                  onUpdateCrossfadeDuration,
                  onPlayNextSong,
                  onTriggerManualVotation,
                  hasVotes = false,
                  onResetVotes
                 }) {

    const { t } = useTranslation();
    const [reloadPlaylist , setReloadPlaylist] = useState();
    const [isConfigOpen, setIsConfigOpen] = useState(false);
    const [configTab, setConfigTab] = useState(0);

    const handleOpenConfigModal = (tab = 0) => {
      setConfigTab(tab);
      setIsConfigOpen(true);
    };

    const handleCloseConfigModal = () => {
      setIsConfigOpen(false);
    };

    // Soporte para abrir modal si se recibe ?config=true en URL
    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      if (params.get('config') === 'true') {
        const tabParam = parseInt(params.get('tab') || '0', 10);
        handleOpenConfigModal(isNaN(tabParam) ? 0 : tabParam);
        window.history.replaceState({}, '', window.location.pathname);
      }
    }, []);

    // Disparar paseo interactivo automáticamente si el usuario nuevo aún no lo ha completado
    useEffect(() => {
      const timer = setTimeout(() => {
        startInteractiveTour(false);
      }, 1200);
      return () => clearTimeout(timer);
    }, []);

    // Mantener proporción 100% fija bloqueando zoom accidental de navegador
    useEffect(() => {
      const handleWheel = (e) => {
        if (e.ctrlKey) {
          e.preventDefault();
        }
      };

      const handleKeyDown = (e) => {
        if (e.ctrlKey && (e.key === '+' || e.key === '-' || e.key === '=' || e.key === '0' || e.keyCode === 187 || e.keyCode === 189 || e.keyCode === 48)) {
          e.preventDefault();
        }
      };

      window.addEventListener('wheel', handleWheel, { passive: false });
      window.addEventListener('keydown', handleKeyDown);

      return () => {
        window.removeEventListener('wheel', handleWheel);
        window.removeEventListener('keydown', handleKeyDown);
      };
    }, []);

    return (
      <div className="pannel-layout" id="pannel-root">
        {/* Background glow orbs estilo Landing Page */}
        <div className="pannel-bg-orb pannel-bg-orb--1" />
        <div className="pannel-bg-orb pannel-bg-orb--2" />
        <div className="pannel-bg-orb pannel-bg-orb--3" />

        <HeaderAppBar 
          user={user} 
          openVideoPlayer={openVideoPlayer} 
          allowInteractivity={allowInteractivity}
          setCurrentIntroVideo={setCurrentIntroVideo} 
          setCurrentTransitionVideo={setCurrentTransitionVideo} 
          currentIntroVideo={currentIntroVideo} 
          currentTransitionVideo={currentTransitionVideo} 
          showHideModalQR={showHideModalQR}
          showHideModalMessage={showHideModalMessage}
          videoPlayer={videoPlayer}
          userSettings={userSettings}
          handleGoogleSignOut={handleGoogleSignOut}
          setVideoId={setVideoId}
          showModalMessage={showModalMessage}
          showModalQR={showModalQR}
          showModalVotesTable={showModalVotesTable}
          showHideModalVotesTable={showHideModalVotesTable}
          openConfigModal={handleOpenConfigModal}
          screenSettings={screenSettings}
          onUpdateScreenSettings={onUpdateScreenSettings}
          onResetScreenSettings={onResetScreenSettings}
          isIntegratedScreen={isIntegratedScreen}
          onToggleIntegratedScreen={onToggleIntegratedScreen}
          isRemoteActive={isRemoteActive}
          onTriggerManualVotation={onTriggerManualVotation}
          currentPlaylistItem={currentPlaylistItem}
          playlist={playlist}
          videoId={videoId}
          hasVotes={hasVotes}
          onResetVotes={onResetVotes}
        />

        {isIntegratedScreen ? (
          <main className="pannel-grid is-integrated">
            {/* Columna Izquierda (30%): Cards de gestión apiladas con scroll */}
            <div className="pannel-column--stacked">
              {/* 1. Controles de Pantalla (Intros, Transiciones, Mensaje, QR, Votos) */}
              <ScreenControlsCard
                currentIntroVideo={currentIntroVideo}
                currentTransitionVideo={currentTransitionVideo}
                handleChangeIntro={(e) => setCurrentIntroVideo(e.target.value)}
                handleChangeTransition={(e) => setCurrentTransitionVideo(e.target.value)}
                openVideoPlayer={openVideoPlayer}
                showHideModalMessage={showHideModalMessage}
                showModalMessage={showModalMessage}
                showHideModalQR={showHideModalQR}
                showModalQR={showModalQR}
                showHideModalVotesTable={showHideModalVotesTable}
                showModalVotesTable={showModalVotesTable}
                hasVotes={hasVotes}
                onResetVotes={onResetVotes}
                allowInteractivity={allowInteractivity}
                onToggleIntegratedScreen={onToggleIntegratedScreen}
                openConfigModal={handleOpenConfigModal}
                userSettings={userSettings}
                screenVolume={screenSettings?.volume}
                onUpdateScreenVolume={(val, commit) => {
                  if (onUpdateScreenSettings) {
                    onUpdateScreenSettings({ volume: val }, commit);
                  }
                }}
                userId={user?.uid}
                onTriggerManualVotation={onTriggerManualVotation}
                currentPlaylistItem={currentPlaylistItem}
                playlist={playlist}
                isIntegratedScreen={isIntegratedScreen}
                videoPlayer={videoPlayer}
                videoId={videoId}
              />

              {/* 2. Búsqueda */}
              <div id="tour-search-bar" className="pannel-column-item-fixed">
                <SearchCard 
                  setKeySearch={setKeySearch} 
                  keySearch={keySearch} 
                  setVideosSearchResponse={setVideosSearchResponse} 
                  isKaraokeOnly={isKaraokeOnly} 
                  onIsKaraokeOnly={onIsKaraokeOnly} 
                  setSnackMessage={setSnackMessage}
                  userSettings={userSettings}
                  selectedApiKey={selectedApiKey}
                  setSelectedApiKey={setSelectedApiKey}
                />
              </div>

              {/* 3. Resultados de búsqueda */}
              <div style={{ height: 380, display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
                <SearchResult 
                  videos={videosSearchResponse} 
                  setPreviewVideoId={setPreviewVideoId} 
                  openVideoPlayer={openVideoPlayer} 
                  setPlaylist={setPlaylist} 
                  playlist={playlist} 
                  setReloadPlaylist={setReloadPlaylist} 
                  currentPlaylist={currentPlaylist}
                  myPlaylists={myPlaylists}
                  userPresetPlaylists={userPresetPlaylists}
                  onAddToPlaylist={onAddToPlaylist}
                  setCurrentPlaylistItem={setCurrentPlaylistItem}
                  currentPlaylistItem={currentPlaylistItem}
                  setVideoId={setVideoId}
                  videoId={videoId}
                  isIntegratedScreen={isIntegratedScreen}
                />
              </div>

              {/* 4. Playlist */}
              <div id="tour-playlist-card" style={{ height: 400, display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
                <PlayListCard 
                  playlist={playlist} 
                  openVideoPlayer={openVideoPlayer} 
                  videoPlayNow={openVideoPlayer} 
                  setReloadPlaylist={setReloadPlaylist} 
                  reloadPlaylist={reloadPlaylist}
                  setPlaylist={setPlaylist} 
                  currentPlaylist={currentPlaylist}
                  setCurrentPlaylist={setCurrentPlaylist}
                  myPlaylists={myPlaylists}
                  setMyPlaylists={setMyPlaylists}
                  onCreatePlaylist={onCreatePlaylist}
                  onRenamePlaylist={onRenamePlaylist}
                  onDeletePlaylist={onDeletePlaylist}
                  userPresetPlaylists={userPresetPlaylists}
                  originPresetPlaylists={originPresetPlaylists}
                  setOriginPresetPlaylists={setOriginPresetPlaylists}
                  originPresetPlaylist={originPresetPlaylist}
                  setOriginPresetPlaylist={setOriginPresetPlaylist}
                  userPresetPlaylist={userPresetPlaylist}
                  setUserPresetPlaylist={setUserPresetPlaylist}
                  setCurrentPlaylistItem={setCurrentPlaylistItem}
                  currentPlaylistItem={currentPlaylistItem}
                  setVideoId={setVideoId}
                  videoId={videoId}
                  isIntegratedScreen={isIntegratedScreen}
                  continuousPlay={continuousPlay}
                  onToggleContinuousPlay={onToggleContinuousPlay}
                  crossfadeEnabled={crossfadeEnabled}
                  onToggleCrossfade={onToggleCrossfade}
                  crossfadeDuration={crossfadeDuration}
                  onUpdateCrossfadeDuration={onUpdateCrossfadeDuration}
                />
              </div>

              {/* 5. PreviewCard NO se renderiza en modo integrado según requerimiento */}

              {/* 6. Efectos de sonido al final (3 veces más alto en modo integrado para mayor visibilidad) */}
              <div id="tour-sound-effects" style={{ height: 780, display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
                <EffectsCard />
              </div>
            </div>

            {/* Columna Derecha (70%): Reproductor Integrado */}
            <div className="pannel-integrated-player-wrap">
              <div className="pannel-integrated-player-header">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#00ff88', boxShadow: '0 0 8px #00ff88' }} />
                  <span style={{ fontSize: '0.74rem', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: 'rgba(255, 255, 255, 0.85)' }}>
                    {t('screenControls.integratedScreenTitle')}
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Button
                    size="small"
                    startIcon={<ExternalLink size={12} />}
                    onClick={() => {
                      if (openVideoPlayer) openVideoPlayer(currentTransitionVideo, true);
                    }}
                    sx={{
                      fontSize: '0.68rem',
                      textTransform: 'none',
                      py: '2px',
                      px: '8px',
                      minWidth: 0,
                      color: 'rgba(255, 255, 255, 0.75)',
                      borderRadius: '6px',
                      background: 'rgba(255, 255, 255, 0.06)',
                      '&:hover': { color: '#00d4ff', background: 'rgba(0, 212, 255, 0.16)' }
                    }}
                  >
                    {t('screenControls.undock')}
                  </Button>
                </div>
              </div>
              <div className="pannel-integrated-player-content">
                <Player
                  isIntegrated={true}
                  updateUserField={updateUserField}
                  currentPlaylistItem={currentPlaylistItem}
                  currentTransitionVideo={currentTransitionVideo}
                  currentIntroVideo={currentIntroVideo}
                  allowInteractivity={allowInteractivity}
                  showControlsPlayer={showControlsPlayer}
                  setVideoId={setVideoId}
                  videoId={videoId}
                  userId={user?.uid}
                  continuousPlay={continuousPlay}
                  crossfadeEnabled={crossfadeEnabled}
                  crossfadeDuration={crossfadeDuration}
                  onPlayNextSong={onPlayNextSong}
                />
              </div>
            </div>
          </main>
        ) : (
          <main className="pannel-grid">
            {/* Columna 1: Búsqueda + Playlist */}
            <div className="pannel-column">
              <div className="pannel-column-item-fixed" id="tour-search-bar">
                <SearchCard 
                  setKeySearch={setKeySearch} 
                  keySearch={keySearch} 
                  setVideosSearchResponse={setVideosSearchResponse} 
                  isKaraokeOnly={isKaraokeOnly} 
                  onIsKaraokeOnly={onIsKaraokeOnly} 
                  setSnackMessage={setSnackMessage}
                  userSettings={userSettings}
                  selectedApiKey={selectedApiKey}
                  setSelectedApiKey={setSelectedApiKey}
                />
              </div>
              <div className="pannel-column-item-fill" id="tour-playlist-card">
                <PlayListCard 
                  playlist={playlist} 
                  openVideoPlayer={openVideoPlayer} 
                  videoPlayNow={openVideoPlayer} 
                  setReloadPlaylist={setReloadPlaylist} 
                  reloadPlaylist={reloadPlaylist}
                  setPlaylist={setPlaylist} 
                  currentPlaylist={currentPlaylist}
                  setCurrentPlaylist={setCurrentPlaylist}
                  myPlaylists={myPlaylists}
                  setMyPlaylists={setMyPlaylists}
                  onCreatePlaylist={onCreatePlaylist}
                  onRenamePlaylist={onRenamePlaylist}
                  onDeletePlaylist={onDeletePlaylist}
                  userPresetPlaylists={userPresetPlaylists}
                  originPresetPlaylists={originPresetPlaylists}
                  setOriginPresetPlaylists={setOriginPresetPlaylists}
                  originPresetPlaylist={originPresetPlaylist}
                  setOriginPresetPlaylist={setOriginPresetPlaylist}
                  userPresetPlaylist={userPresetPlaylist}
                  setUserPresetPlaylist={setUserPresetPlaylist}
                  setCurrentPlaylistItem={setCurrentPlaylistItem}
                  currentPlaylistItem={currentPlaylistItem}
                  setVideoId={setVideoId}
                  videoId={videoId}
                  isIntegratedScreen={isIntegratedScreen}
                  continuousPlay={continuousPlay}
                  onToggleContinuousPlay={onToggleContinuousPlay}
                  crossfadeEnabled={crossfadeEnabled}
                  onToggleCrossfade={onToggleCrossfade}
                  crossfadeDuration={crossfadeDuration}
                  onUpdateCrossfadeDuration={onUpdateCrossfadeDuration}
                />
              </div>
            </div>

            {/* Columna 2: Resultados de búsqueda */}
            <div className="pannel-column">
              <div className="pannel-column-item-fill">
                <SearchResult 
                  videos={videosSearchResponse} 
                  setPreviewVideoId={setPreviewVideoId} 
                  openVideoPlayer={openVideoPlayer} 
                  setPlaylist={setPlaylist} 
                  playlist={playlist} 
                  setReloadPlaylist={setReloadPlaylist} 
                  currentPlaylist={currentPlaylist}
                  myPlaylists={myPlaylists}
                  userPresetPlaylists={userPresetPlaylists}
                  onAddToPlaylist={onAddToPlaylist}
                  setCurrentPlaylistItem={setCurrentPlaylistItem}
                  currentPlaylistItem={currentPlaylistItem}
                  setVideoId={setVideoId}
                  videoId={videoId}
                  isIntegratedScreen={isIntegratedScreen}
                />
              </div>
            </div>

            {/* Columna 3: Previsualizador + Efectos de Sonido */}
            <div className="pannel-column">
              <div className="pannel-column-item-fixed">
                <PreviewCard videoId={previewVideId} />
              </div>
              <div className="pannel-column-item-fill" id="tour-sound-effects">
                <EffectsCard />
              </div>
            </div>
          </main>
        )}

        <ConfigModal
          open={isConfigOpen}
          onClose={handleCloseConfigModal}
          initialTab={configTab}
          auth={auth}
          user={user}
          userSettings={userSettings}
          saveUserSettings={saveUserSettings}
          setAllowInteractivity={setAllowInteractivity}
          allowInteractivity={allowInteractivity}
          setShowControlsPlayer={setShowControlsPlayer}
          showControlsPlayer={showControlsPlayer}
          setSnackMessage={setSnackMessage}
        />
      </div>
    
  );
}
export default Pannel;